import {
  ProgramHeaderBlock,
  ProgramHeaderCopy,
  ProgramSubtitle,
  ProgramTitle,
} from "./ProgramMap.styles";
import { useI18n } from "../../../i18n/I18nProvider";

export const ProgramHeader = () => {
  const { t } = useI18n();
  return <ProgramHeaderBlock>
    <ProgramHeaderCopy>
      <ProgramTitle>{t("Программа")}</ProgramTitle>
      <ProgramSubtitle>
        {t("Выберите уровень и отправляйтесь в новое приключение! 🚀")}
      </ProgramSubtitle>
    </ProgramHeaderCopy>
  </ProgramHeaderBlock>;
};
